import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import { LOCATION_CHANGE } from 'connected-react-router';
import { matchPath } from 'connected-react-router';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import { initialState } from '../../utils/redux/commonActionHandlers';

export const constants = getConstantsByFeatureName('ASSIGNED_USERS');
export const actions = getActionCreators(constants);
export const actionHandlers = getActionHandlers(constants);
export const reducer = buildReducer(initialState, {
  ...actionHandlers,
  [LOCATION_CHANGE]: (state, { payload: { location: { pathname } } }) => (
    matchPath(pathname, { path: '/vessels/:id/details' })
      ? state
      : initialState
  ),
});
